import { combineReducers } from '@reduxjs/toolkit';
import generalInfoBasicReducer from './generalInfoSlice';
import generalInfoIntroReducer, { GeneralInfoIntroFormState } from './Introduction/generalInfoIntroSlice';
import generalInfoBusinessReducer, { GeneralInfoBusinessFormState } from './Business/generalInfoBusinessSlice';
import generalInfoLocationsReducer, { GeneralInfoLocationFormState } from './Locations/generalInfoLocationsSlice';
import generalInfoMobilityReducer, { GeneralInfoMobilityFormState } from './Mobility/generalInfoMobilitySlice';
import generalInfoAvailabilityReducer, { GeneralInfoAvailabilityFormState } from './Availability/generalInfoAvailablitySlice';
import generalInfoSocialNetworksReducer, { GeneralInfoSocialNetworkFormState } from './SocialNetworks/generalInfoSocialNetworksSlice';
import generalInfoExternalLinksReducer, { GeneralInfoExternalLinksFormState } from './Links/generalInfoLinksSlice';
import { OnboardingStepState } from '../../onboardingSlice';

export interface GeneralInfoState {
  basic: OnboardingStepState;
  introduction: GeneralInfoIntroFormState;
  business: GeneralInfoBusinessFormState;
  locations: GeneralInfoLocationFormState[];
  mobility: GeneralInfoMobilityFormState;
  availability: GeneralInfoAvailabilityFormState;
  socialNetworks: GeneralInfoSocialNetworkFormState[];
  externalLinks: GeneralInfoExternalLinksFormState[];
}

export const generalInfoReducer = combineReducers({
  basic: generalInfoBasicReducer,
  introduction: generalInfoIntroReducer,
  business: generalInfoBusinessReducer,
  locations: generalInfoLocationsReducer,
  mobility: generalInfoMobilityReducer,
  availability: generalInfoAvailabilityReducer,
  socialNetworks: generalInfoSocialNetworksReducer,
  externalLinks: generalInfoExternalLinksReducer,
});

export default generalInfoReducer;
